import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LtiRelinkComponent } from './lti-relink.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LtiRelinkComponent],
  exports: [LtiRelinkComponent],
})
export class LtiRelinkModule {}
